import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LogoutPage = () => {
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (!hasLoggedOut.current) {
      const performLogout = async () => {
        try {
          await logout();
          hasLoggedOut.current = true; // Mark that logout has been performed
        } catch (error) {
          console.error('Logout error:', error);
        } finally {
          // Always navigate to login after logout is attempted
          navigate('/login', { replace: true });
        }
      };

      performLogout();
    }
  }, [logout, navigate, isAuthenticated]); // isAuthenticated added as dependency

  return (
    <div className="logout-page" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '16px',
      backgroundColor: '#f7fafc'
    }}>
      <div className="loading-spinner" style={{
        width: '40px',
        height: '40px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #667eea',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p style={{ color: '#718096', fontSize: '16px' }}>Logging out...</p>
    </div>
  );
};

export default LogoutPage;
